import React from 'react';
import './App.scss';
import './Mobile.scss';
//import Grid from '@material-ui/core/Grid';
import { connect } from 'react-redux';
import SideBar from './components/SideBar/SideBar';
import WidgetCarousel from './components/Carousel/Carousel';
import LoadingScreen from './components/Loading/LoadingScreen';

import * as actions from './actions/actions';

type Props = {
  loadWeather: Function,
  loadWidgets: Function,
  widgets: Array,
  leftPanel: Object,
  whiteLabel: Object,
  isShowMenu: boolean
};

class App extends React.Component<Props> {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      // loading: false,
      intervalId: 0,
      deviceWidth: window.innerWidth
    };
  }

  componentWillMount() {
    this.getWidgets();
  }

  componentDidMount() {
    var intervalId = setInterval(this.getWidgets, 3600000);
    this.setState({ intervalId: intervalId });

    window.addEventListener(
      'resize',
      () => {
        this.setState({
          deviceWidth: window.innerWidth
        });
      },
      false
    );
  }

  componentWillReceiveProps(nextProps) {
    const { whiteLabel } = this.props;
    if(nextProps.whiteLabel !== whiteLabel) {
      if(nextProps.whiteLabel) {
        if(nextProps.whiteLabel.small_logo && nextProps.whiteLabel.small_logo !== null) {
          var favicon = document.querySelector('#favlink')
          favicon.setAttribute('type', 'image/png')
          favicon.setAttribute('href', nextProps.whiteLabel.small_logo)
        }
        // if(nextProps.whiteLabel.ui_settings && nextProps.whiteLabel.ui_settings.primaryColor && nextProps.whiteLabel.ui_settings.primaryColor !== null) {
        //   var topbar = document.querySelector('header.topbar')
        //   topbar.style.cssText = `background-color: ${nextProps.whiteLabel.ui_settings.primaryColor} !important`
        // }
        document.title = nextProps.whiteLabel.product_name
      }
      this.setState({ loading: false });
    }
  }

  componentWillUnmount() {
    const { intervalId } = this.state;
    clearInterval(intervalId);
  }

  getWidgets = () => {
    const { loadWeather, loadWidgets } = this.props;
    const buildingId = window.location.pathname.split('/').pop() || 41;
    // this.setState({ loading: true });
    loadWidgets(buildingId, () => {
      loadWeather(7);
      // this.setState({ loading: false });
    });
  };

  render() {
    const { widgets, leftPanel, isShowMenu } = this.props;
    const { loading, deviceWidth } = this.state;
    let className = 'App';
    if (deviceWidth < 600) {
      className += ' mobile';
      if (isShowMenu) {
        className += ' toggleBody';
      }
    }

    return (
      <div className={className}>
        <SideBar logo={leftPanel.logo} city={leftPanel.building.city} />
        <WidgetCarousel widgets={widgets} deviceWidth={deviceWidth} />
        {loading && <LoadingScreen />}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    widgets: state.widgetReducer.data,
    leftPanel: state.widgetReducer.leftPanel,
    whiteLabel: state.widgetReducer.whiteLabel,
    isShowMenu: state.widgetReducer.isShowMenu
  };
};

const mapDispatchToProps = dispatch => {
  return {
    loadWeather: days => {
      dispatch(actions.loadWeather(days));
    },
    loadWidgets: (buildingId, cb) => {
      if (!Number.isInteger(Number(buildingId))) {
        dispatch(actions.loadFoyers(buildingId)).then(() => cb());
      } else {
        dispatch(actions.loadWidgets(buildingId)).then(() => cb());
      }
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);
